import { render, staticRenderFns } from "./DocumentCardSales.vue?vue&type=template&id=3242dc5c&scoped=true"
import script from "./DocumentCardSales.vue?vue&type=script&lang=js"
export * from "./DocumentCardSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3242dc5c",
  null
  
)

export default component.exports